import jwt from "../../http/requests/auth/jwt/index.js";

export default {
  async sendMessage({ commit, state }, text) {
    if (!text.trim() || state.isLoading) return;

    // Add User Message
    commit("ADD_MESSAGE", { role: "user", text: text.trim() });
    commit("SET_LOADING", true);

    try {
      const res = await jwt.getChatBotResponse({ query: text.trim() });
      const data = res.data;
      const botText =
        data.answer || data.response || "Sorry, I couldn't find an answer.";

      commit("ADD_MESSAGE", { role: "bot", text: botText });
    } catch (err) {
      commit("ADD_MESSAGE", {
        role: "bot",
        text: "Connection error. Please try again.",
      });
    } finally {
      commit("SET_LOADING", false);
    }
  },
};
